module.exports = __webpack_public_path__ + "2d3ea42b70ebe451b9718c86bf8339b7.svg";